var Header = function Header(_ref) {
  var spacing = _ref.spacing;
  return {
    padding: {
      xxs: spacing.medium,
      lg: spacing.huge
    },
    height: {
      xxs: 56,
      lg: 72
    }
  };
};

export default Header;